import React from 'react';

// Capturing group so String.split keeps the matched URLs in the result,
// interleaved with the surrounding plain text at odd indices.
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)'"\]])/gi;

export function extractUrls(text) {
  if (!text) return [];
  return text.match(URL_REGEX) || [];
}

/** Renders text with any http(s) URL turned into a clickable link — the
 * "paste a link and it becomes clickable" behavior from Facebook posts. */
export function linkifyText(text, linkClassName = 'underline break-all hover:no-underline') {
  if (!text) return null;
  return text.split(URL_REGEX).map((part, i) => (
    i % 2 === 1
      ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" className={linkClassName}>{part}</a>
      : <React.Fragment key={i}>{part}</React.Fragment>
  ));
}
